export default class GetPermittedBuetoothDeviceError extends Error {
    constructor(message = '', ...args) {
        super(message, ...args);
        this.message = 'getPermittedBluetoothDevices timeout error';
    }
}
